import React from "react";
import Header from "../../elements/Header";
import Footer from "../../elements/Footer";
import FAQ from "../../elements/FAQ";

const breakpoints = [755];
const mq = breakpoints.map((bp) => `@media (min-width: ${bp}px)`);

// COA documents are served as static files from /public/coa/.
// To add a new COA: drop the PDF into public/coa/ and append an entry below.
const COA_FILES = [
  { title: "Canabotanica - Apple Fritter", file: "/coa/Canabotanica - Apple Fritter.pdf" },
  { title: "Canabotanica - Cobra Chi", file: "/coa/Canabotanica - Cobra Chi.pdf" },
  { title: "Canabotanica - Miracle Fruit", file: "/coa/Canabotanica - Miracle Fruit.pdf" },
  { title: "Canabotanica - Molotov Cocktail", file: "/coa/Canabotanica - Molotov Cocktail.pdf" },
  { title: "Guilty Pleasure - Cherry Zlushie", file: "/coa/Guilty Pleasure - Cherry Zlushie.pdf" },
  { title: "Guilty Pleasure - Rainbow Sherbet", file: "/coa/Guilty Pleasure - Rainbow Sherbet.pdf" },
  { title: "Guilty Pleasure - Strawberry Milkshake", file: "/coa/Guilty Pleasure - Strawberry Milkshake.pdf" },
  { title: "Guilty Pleasure - Tropicana Cookies", file: "/coa/Guilty Pleasure - Tropicana Cookies.pdf" },
  { title: "Guilty Pleasure - Watermelon Sugar", file: "/coa/Guilty Pleasure - Watermelon Sugar.pdf" },
  { title: "High Rise - Blood Orange", file: "/coa/High Rise - Blood Orange.pdf" },
  { title: "High Rise - Blueberry", file: "/coa/High Rise - Blueberry.pdf" },
  { title: "High Rise - Grapefruit", file: "/coa/High Rise - Grapefruit.pdf" },
  { title: "High Rise - Mango", file: "/coa/High Rise - Mango.pdf" },
  { title: "Kiva Camino - Midnight Blueberry", file: "/coa/Kiva Camino - Midnight Blueberry.pdf" },
  { title: "Kiva Camino - Sparkling Pear", file: "/coa/Kiva Camino - Sparkling Pear.pdf" },
  { title: "Kiva Camino - Wild Berry", file: "/coa/Kiva Camino - Wild Berry.pdf" },
  { title: "Loopt - Guava Nectar", file: "/coa/Loopt - Guava Nectar.pdf" },
  { title: "Loopt - Mango Splash", file: "/coa/Loopt - Mango Splash.pdf" },
  { title: "Loopt - Purple Kush", file: "/coa/Loopt - Purple Kush.pdf" },
  { title: "Loopt - SFV OG", file: "/coa/Loopt - SFV OG.pdf" },
  { title: "Loopt - Sherbacio", file: "/coa/Loopt - Sherbacio.pdf" },
  { title: "Loopt - Strawberry", file: "/coa/Loopt - Strawberry.pdf" },
  { title: "Loopt - Sunset Sherbert", file: "/coa/Loopt - Sunset Sherbert.pdf" },
  { title: "Loopt - Watermelon", file: "/coa/Loopt - Watermelon.pdf" },
  { title: "Loopt - Watermelon Gusherz", file: "/coa/Loopt - Watermelon Gusherz.pdf" },
  { title: "Mary's - Remedy PM Tincture", file: "/coa/Mary's - Remedy PM Tincture.pdf" },
  { title: "Mary's - The Remedy Tincture", file: "/coa/Mary's - The Remedy Tincture.pdf" },
  { title: "Pacific Gold - Guava Kush", file: "/coa/Pacific Gold - Guava Kush.pdf" },
  { title: "Pacific Gold - Pineapple Express", file: "/coa/Pacific Gold - Pineapple Express.pdf" },
  { title: "Pacific Gold - Strawberry Diesel", file: "/coa/Pacific Gold - Strawberry Diesel.pdf" },
  { title: "Pacific Gold - Super Lemon Haze", file: "/coa/Pacific Gold - Super Lemon Haze.pdf" },
  { title: "Pacific Gold - Watermelon Kush", file: "/coa/Pacific Gold - Watermelon Kush.pdf" },
  { title: "Paradise Smokes - Dragonzfruit", file: "/coa/Paradise Smokes - Dragonzfruit.pdf" },
  { title: "Paradise Smokes - Elder Berries", file: "/coa/Paradise Smokes - Elder Berries.pdf" },
  { title: "Paradise Smokes - Frozen Lemonz", file: "/coa/Paradise Smokes - Frozen Lemonz.pdf" },
  { title: "The Distro Co - Apple Fritter", file: "/coa/The Distro Co - Apple Fritter.pdf" },
  { title: "The Distro Co - Cereal Milk", file: "/coa/The Distro Co - Cereal Milk.pdf" },
  { title: "The Distro Co - GDP", file: "/coa/The Distro Co - GDP.pdf" },
  { title: "The Distro Co - GSC", file: "/coa/The Distro Co - GSC.pdf" },
  { title: "The Distro Co - Motorbreath", file: "/coa/The Distro Co - Motorbreath.pdf" },
  { title: "The Distro Co - Platinum OG", file: "/coa/The Distro Co - Platinum OG.pdf" },
  { title: "The Distro Co - Rainbow Runtz", file: "/coa/The Distro Co - Rainbow Runtz.pdf" },
  { title: "The Distro Co - Skywalker OG", file: "/coa/The Distro Co - Skywalker OG.pdf" },
  { title: "The Distro Co - Watermelon Z", file: "/coa/The Distro Co - Watermelon Z.pdf" },
  { title: "Triple Pleasure - Cherry Zlushie", file: "/coa/Triple Pleasure - Cherry Zlushie.pdf" },
  { title: "Triple Pleasure - Rainbow Sherbet", file: "/coa/Triple Pleasure - Rainbow Sherbet.pdf" },
  { title: "Triple Pleasure - Tropicana Cookies", file: "/coa/Triple Pleasure - Tropicana Cookies.pdf" },
  { title: "Triple Pleasure - Watermelon Sugar", file: "/coa/Triple Pleasure - Watermelon Sugar.pdf" },
  { title: "Wana - Blueberry Lemonade", file: "/coa/Wana - Blueberry Lemonade.pdf" },
  { title: "Wana - Fast Asleep", file: "/coa/Wana - Fast Asleep.pdf" },
  { title: "Wana - Raspberry Limeade", file: "/coa/Wana - Raspberry Limeade.pdf" },
  { title: "Wana - Stay Asleep", file: "/coa/Wana - Stay Asleep.pdf" },
  { title: "Wyld - Elderberry", file: "/coa/Wyld - Elderberry.pdf" },
  { title: "Wyld - Huckleberry", file: "/coa/Wyld - Huckleberry.pdf" },
  { title: "Wyld - Marionberry", file: "/coa/Wyld - Marionberry.pdf" },
  { title: "Wyld - Pear", file: "/coa/Wyld - Pear.pdf" },
  { title: "Wyld - Pomegranate", file: "/coa/Wyld - Pomegranate.pdf" },
  { title: "Wynk - Black Cherry", file: "/coa/Wynk - Black Cherry.pdf" },
  { title: "Wynk - Juicy Mango", file: "/coa/Wynk - Juicy Mango.pdf" },
  { title: "Wynk - Lime Twist", file: "/coa/Wynk - Lime Twist.pdf" },
  { title: "Wynk - Tangerine", file: "/coa/Wynk - Tangerine.pdf" },
];

const CertificatesOfAnalysis = () => {
  return (
    <div>
      <Header />
      <div
        css={{
          padding: "20px 20px 40px",
          maxWidth: "1140px",
          margin: "0 auto",
          [mq[0]]: { fontSize: "1.1rem" },
        }}
      >
        <h1 css={styles.title}>Certificates of Analysis (COA)</h1>

        {COA_FILES.length === 0 ? (
          <div css={styles.empty} />
        ) : (
          <ul css={styles.list}>
            {COA_FILES.map((coa) => (
              <li key={coa.file} css={styles.listItem}>
                <a
                  css={styles.fileLink}
                  href={coa.file}
                  target="_blank"
                  rel="noreferrer"
                >
                  {coa.title}
                </a>
              </li>
            ))}
          </ul>
        )}

        <FAQ />
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  title: {
    fontSize: "1.6rem",
    fontWeight: 700,
    margin: "10px 0 16px",
    [mq[0]]: { fontSize: "2rem" },
  },
  empty: {
    border: "1px dashed #ccc",
    borderRadius: 8,
    minHeight: 60,
    marginTop: 8,
  },
  list: {
    listStyle: "none",
    padding: 0,
    margin: "20px 0 40px",
    borderTop: "1px solid #eee",
  },
  listItem: {
    borderBottom: "1px solid #eee",
  },
  fileLink: {
    display: "block",
    padding: "14px 4px",
    color: "#111",
    textDecoration: "none",
    fontWeight: 500,
    "&:hover": { color: "#000", textDecoration: "underline" },
  },
};

export default CertificatesOfAnalysis;
